import React from 'react'
import './tabs-row.scss'

/**
 * The props
 */
export interface TabsRowProps {
    /**
     * The label to display left
     */
    label: string

    /**
     * Specify the width of the label
     */
    labelWidth?: number
}

/**
 * Represents a row within the tabs component.
 * 
 * @author Stan Hurks
 */
export default class TabsRow extends React.Component<TabsRowProps> {

    public render = () => {
        return (
            <div className="tabs-row">
                <div className="tabs-row-label" style={{
                    ...this.props.labelWidth !== undefined
                    && {
                        width: this.props.labelWidth
                    }
                }}>
                    {
                        this.props.label
                    }
                </div>
                <div className="tabs-row-content">
                    {
                        this.props.children
                    }
                </div>
            </div>
        )
    }
}